const themePath = main_scripts.dist_path;

window.collections = {};

const SCRIPTS = [
    {
        'url' : main_scripts.header,
        'sel' : 'header',
        'col' : 'header'
    },
    {
        'url' : main_scripts.openDialog,
        'sel' : '#open-search',
        'col' : 'openDialog'
    }
];

let selectors = [];
for (let script of SCRIPTS) {
    selectors.push(script.sel);
}

const obj_present = Array.from(document.querySelectorAll(selectors.join(',')));
for (let script of SCRIPTS) {
    collections[script.col] = obj_present.filter(item => item.matches(script.sel));
    if (collections[script.col].length > 0) {
        import(themePath + script.url)
            .catch(console.error)
        ;
    }
}

